import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'pk-broker-auction-help',
	templateUrl: './auction-help.component.html',
	styleUrls: ['./auction-help.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class AuctionHelpComponent {}
